import React from "react";

import css from "./Card.module.scss";

type CardProps = {
	/**
	 * Children of the card
	 */
	children: React.ReactNode;
	/**
	 * Additional class name
	 */
	className?: string;
	/**
	 * Additional style
	 */
	style?: React.CSSProperties;
	/**
	 * Border around the card
	 */
	border?: boolean;
	/**
	 * Padding around the card
	 * @default "32px 40px"
	 */
	padding?: string;
	/**
	 * Function to call on click
	 */
	onClick?: () => void;
};

const Card = ({ children, className, style, border, padding = "32px 40px", onClick }: CardProps) => {
	return (
		<div
			className={`${css.card} ${border ? css.bordered : null} ${className}`}
			style={{ padding, ...style }}
			onClick={onClick}
		>
			{children}
		</div>
	);
};

export default Card;
